
<script>
  import { onMount } from "svelte";
  import { ICONS } from "../js/icons";
  import backend from "../server";
 
  import moment from 'moment';
  import Form_Novus from "../lib/components/modals/freebets/novus/Form.svelte";
  import Toaster from '../lib/components/modals/freebets/novus/Toaster.svelte';
  import FormAddPlayers from '../lib/components/modals/freebets/novus/FormAddPlayers.svelte';
  import FormAddGames from '../lib/components/modals/freebets/novus/FormAddGames.svelte';
  import Pagination from '../lib/components/modals/freebets/novus/Pagination.svelte';

  let currentPage = 1;
  let filters = {
  page: currentPage,limit: 10, id: '', client_campaign_title: '', player_count: '',
  provider_id:  '', type:  '',is_bonus_money:  '', status: '' 
  };
  let isNew = false;
  let campaigns = [];  
  let isLoading = true;
  let errorMessage = '';
  let showFilters = false; 
  let campaign = null; 
  let isModalPlayer= false;
  let campaignSelect=null;
  let isModalGame=false;
  let isShowToast = false;
  let toastMessage = '';
  let toastType = ''; 

  let totalPages = 0; 

  let bonuses = {
        id: '',
        client_campaign_title: "",
        free_round_count: 25,
        player_count: 0,
        provider_id: 6,
        type: "random",
        start_date: moment().utc().format("YYYY-MM-DD HH:mm:ss"),  
        end_date: moment().utc().add(1, 'months').format("YYYY-MM-DD HH:mm:ss"),
        is_enabled: true,
        is_bonus_money: false,
        is_promo:false,
        multiple_redemptions:false,
        wagering: {
            is_enabled: false,
            multiplier: 3,
            expiring_at: moment().utc().add(2, 'months').format("YYYY-MM-DD HH:mm:ss"),
            bet_condition_type: 1
        }
        };

  onMount(async () => {
  await listCampaign()
  });

  const searchEnter = (e) => {
    if (e.charCode === 13);
  };


  const listCampaign = async () => {
    let params = { ...filters };
    isLoading = true; 
      try {
        let response = await backend.freespin.getCampaignNovus(params);
        if (response.data.status) {
          campaigns = response.data.data.campaign_free_rounds; 
          const totalItems = response.data.data.total_count; 
        totalPages = Math.ceil(totalItems / 10);
        console.log(totalPages)
        } else {
         
          campaigns = []; 
          errorMessage = response.data.messages.join(", "); 
        }
      } catch (error) {
      
        errorMessage = response.data.messages.join(", "); 
        console.log(errorMessage)
        campaigns = [];  
      } finally {
        isLoading = false; 
      }
    
  };

  function handlePageChange(page) {
    if (page === currentPage) return;
    filters.page = page; 
    currentPage=page; 
    listCampaign(); 
  }

 

  const created = () => {
    campaign = { ...bonuses };
      isNew = true;
  };
  const edit = (bonuses) => {
    campaign = { ...bonuses };
    console.log(campaign)
      isNew = true;
  };
  const chngeStatus = async (campaign) => {
    try {
      let staus= campaign.status=='Disabled'? true:false;
      let response = await backend.freespin.
      changeStatusCampaignById(campaign.id,staus);
      showToast();
      listCampaign();
     
      } catch (error) {
        showToast('¡Algo salió mal!', 'error');
      console.error("Error fetching free spins:", error);
      }
  };

  const toggleFilters=()=>{
    showFilters = !showFilters;
  }
  const delet = async (campaign) => {
    try {
      let response = await backend.freespin.deleteCampaignById(campaign.id);
      showToast();
      listCampaign();
      } catch (error) {
        showToast('¡Algo salió mal!', 'error');
      console.error("Error fetching free spins:", error);
      }
  };

  const showToast = (message = 'Operación exitosa', type = 'success') => {
    toastMessage = message;
    toastType = type;
    isShowToast = true;
  }

  const addPlayers=(campaign)=>{
    campaignSelect =campaign;
    isModalPlayer = true;
  }

  const addGams=(campaign)=>{
    campaignSelect =campaign;
    isModalGame = true;
  }

  let statusMap = {
  "In Running": { label: "En Ejecución", class: "bg-primary" },
  "Scheduled": { label: "Programada", class: "bg-warning" },
  "Expired": { label: "Expirada", class: "bg-secondary" },
  "Disabled": { label: "Deshabilitada", class: "bg-dark" },
  "Player count fulfilled": { label: "Número de Jugadores Cumplido", class: "bg-success" }
};

</script>

<div class="wrapp">
<div class="menu-filter">
  <div style="display: flex; flex-direction: row; gap: 0.5rem; margin-top: 1rem;">

  <!-- Barra de búsqueda y botones -->
    <input
      on:keypress={searchEnter}
      bind:value={filters.search}
      class="form-control"
      placeholder="Buscar"
      style="flex: 1;" 
    />

    <!-- Botón de búsqueda -->
    <button
    on:click={listCampaign}
    class="btn btn-pink btn-sm"
    title="Buscar"
    disabled={isLoading} >
    {#if isLoading}
      <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span> Cargando...
    {:else}
      {@html ICONS.search}
    {/if}
  </button>
  
    <!-- Botón para nuevo -->
    <button class="btn btn-pink btn-sm" on:click={created}>
      {@html ICONS.add}
    </button>
      <!-- Botón para toggle de filtros -->
    <button class="btn btn-pink btn-sm" on:click={toggleFilters}>
      <i class="fa-solid {showFilters ? 'fa-filter-circle-xmark':'fa-filter'}"></i>
    </button>
  </div>
</div>
</div>


<div class="wrapp">
<div class="menu-filter">

  <!-- Contenedor de filtros con toggle -->
  {#if showFilters}
    <div class="filters-container">
      <div class="row">
        <!-- Filtro 1: ID -->
        <div class="col-md-3">
          <label for="id">ID</label>
          <input type="number" id="id" bind:value={filters.id} class="form-control" placeholder="ID de campaña" />
        </div>
        
        <!-- Filtro 2: Client Campaign Title -->
        <div class="col-md-3">
          <label for="client_campaign_title">Título de campaña</label>
          <input type="text" id="client_campaign_title" bind:value={filters.client_campaign_title} class="form-control" placeholder="Título" />
        </div>
        
        <!-- Filtro 3: Player Count -->
        <div class="col-md-3">
          <label for="player_count">Número de jugadores</label>
          <input type="number" id="player_count" bind:value={filters.player_count} class="form-control" placeholder="Jugadores" />
        </div>
        
        <!-- Filtro 4: Provider ID -->
        <div class="col-md-3">
          <label for="provider_id">Provider ID</label>
          <input type="number" id="provider_id" bind:value={filters.provider_id} class="form-control" placeholder="ID del proveedor" />
        </div>
        <!-- Filtro 5: Type -->
        <div class="col-md-3">
          <label for="type">Tipo</label>
          <input type="text" id="type" bind:value={filters.type} class="form-control" placeholder="Tipo" />
        </div>

        <!-- Filtro 7: Status -->
        <div class="col-md-3">
          <label for="status">Estado</label>
          <input type="text"  bind:value={filters.status} class="form-control" placeholder="Estado" />
        </div>

         <!-- Filtro 8: Xpage (limite de resultados) -->
         <div class="col-md-3">
          <label for="xpage">Cantidad por página</label>
          <input type="number"  bind:value={filters.limit} class="form-control"  />
        </div>

        <!-- Filtro 6: Is Bonus Money -->
        <div class="col-md-3">
          <label for="is_bonus_money">Is Bonus Money</label>
          <select class="form-control"  bind:value={filters.is_bonus_money}>
            <option value={1}>Sí, ofrece dinero de bonificación</option>
             <option value={0}>No, no ofrece dinero de bonificación</option>
        </select>

       
        </div>

      </div>
    </div>
  {/if}
</div>
</div>


<div class="wrapp">

  <div class="alert alert-warning alert-dismissible fade show" role="alert">
    <strong>Tipo de campaña:</strong> Solo puedes agregar jugadores a campañas con tipo "Assigned". <br>
    <strong>Estado de la campaña:</strong> La campaña debe estar en estado "In Running". <br> No se permite agregar jugadores en estados "Scheduled", "Expired", "Disabled" o "Player count fulfilled"
   
  </div>
  
  <div class="container-table">

    <div style="overflow-x: auto;">
      {#if isLoading}
      <p>Cargando...</p>
    {:else}
      {#if campaigns.length > 0}
        <table class="table table-sm">
          <thead>
            <tr>
              <th>N°</th>
              <th>Item</th>
              <th>Título</th>
              <th>N° rondas gratis</th>
              <th>N° jugadores</th>
              <th>Fecha Inicio</th>
              <th>Fecha Fin</th>
              <th>Tipo</th>
              <th>Estado</th>
              <th>Req. requisitos.</th>
              <th>Multiplicador</th>
              <th>Req. expiran</th>
              <th>Cont. bet</th>
              <th colspan="5">Action</th>  
            </tr>
          </thead>
          <tbody>
            {#each campaigns as campaign, index}
              <tr>
                <td>{index + 1}</td> 
                <td>{campaign.id}</td>
                <td>{campaign.client_campaign_title}</td>
                <td>{campaign.free_round_count}</td>
                <td>{campaign.player_count}</td>
                <td>{campaign.start_date}</td>
                <td>{campaign.end_date}</td>
                <td>{campaign.type}</td>
                <td>
                  <span class={`badge ${statusMap[campaign.status]?.class || 'bg-dark'}`}>
                    {statusMap[campaign.status]?.label || 'Desconocido'}
                  </span>
                </td>
                
                <td>{campaign.wagering.is_enabled ? 'Yes' : 'No'}</td>  
                <td>{campaign.wagering.multiplier}</td>
                <td>{campaign.wagering.expiring_at}</td>
                <td>{campaign.wagering.bet_condition_type}</td>
                <td>
                  <div class="button-container">
                    <button on:click={() => edit(campaign)} class="btn btn-secondary btn-sm">
                      {@html ICONS.edit}
                    </button>
                    <button on:click={() => delet(campaign)} class="btn btn-danger btn-sm">
                      {@html ICONS.delete}
                    </button>
                    <button on:click={() => chngeStatus(campaign)}
                       class="btn btn-{campaign.status ==='Scheduled'? 'info' : 'secondary'} btn-sm">
                      <i class="fa-solid {campaign.status ==='Scheduled'? 'fa-toggle-on' : 'fa-toggle-off '}"></i>
                    </button>
                    <button on:click={() => addPlayers(campaign)} class="btn btn-success btn-sm">
                      {@html ICONS.persons}
                    </button>
                    <button on:click={() => addGams(campaign)} class="btn btn-warning btn-sm">
                      {@html ICONS.games}
                    </button>
                    
                  </div>
                </td>
              </tr>
            {/each}
          </tbody>
        </table>
      {:else}
        <p>No se encontraron registros.</p>
        <p style="text-align: center; color: red;">{errorMessage}</p>
      {/if}
      {#if totalPages > 1}
      <Pagination 
        currentPage={currentPage} 
        totalPages={totalPages} 
        onPageChange={handlePageChange}
      />
    {/if}
    {/if}
    <!-- Paginación -->

    
  

    </div>
  </div>
</div>

{#if isNew || campaign}
  <Form_Novus bind:isNew bind:campaign {listCampaign} {showToast}/>
{/if}
{#if isModalPlayer}
  <FormAddPlayers bind:isModalPlayer  bind:campaign ={campaignSelect} />
{/if}
{#if isModalGame}
  <FormAddGames bind:isModalGame  bind:campaign ={campaignSelect} />
{/if}
<Toaster  bind:message={toastMessage} bind:type={toastType} bind:show={isShowToast} />

   





<style>
  .menu-filter {
    display: flex;
    flex-wrap: wrap;
    gap: 0.5rem;
    padding: 0.5rem;
  }
  .button-container {
    display: flex;
    gap: 10px; /* Esto crea un margen de 10px entre los botones */
  }
  .container-table {
    padding: 0.5rem;
  }

  .btn-pink {
   background-color: #2a1a28;
    color: white;
  }
  .btn-pink:hover{
      background-color: #FF0090;
    color: white;
  }
  .wrapp {
  padding: 10px;
  margin: 0;
}

.menu-filter {
  margin: 0;
  padding: 0;
}

.filters-container {
  margin-top: 1rem;
  border: 1px solid #ddd;
  padding: 1rem;
  border-radius: 5px;
}


 


</style>
